module.exports = __webpack_public_path__ + "img/tongxing-pic@2x.8f0eb51b.png";